import React from 'react';
//import Auth from './../auth/Auth';

//import Profile from './../pages/Profile';


import { Route } from 'react-router-dom'

import { Redirect } from 'react-router-dom'

import CommonHelper from '../helpers/CommonHelper';
import Entrance from '../pages/Entrance';
import LinkAccount from '../pages/LinkAccount';
import About from '../pages/About';
import Config from '../Config';

export default class PrivateRoute extends Route {

  // constructor(props){
  //    super(props);
  //    //this.className='plain-label';
  //  }

  //  getDefaultProps () {
  //   return {
  //     Component: 'div',
  //     className: 'component-no-children'
  //   }
  // }

    render(){

      // Create local variables for Component.
   // All additional props get created in an object addressable using the rest variable.
   // This allows additional props to be set on the component, such as { role: 'presentation' }
   // without the component knowing about them ahead of time.
   var { Component, ...rest } = this.props;

   // Create the components element:
   // by default a <div> is created, but this.props.Component could be set to any valid node
   // such as a 'section' or another react component.
   // The {...} part is a destructering operation - it returns each key:value from the rest object.
   // In the case of the default props, it's equivalent to writing className={rest.className}

   //var props = ,,,
   //return (<Route {...rest}/>);

// return (<Component {...props}/>);


      // return <span className={this.className}>
      //    {this.props.children}
      //  </span>
      //  if (Auth.isAuthenticated()) {
      //    return (<Component/>);
      //  }else {
      //    return (<Redirect to={{pathname: '/login', state: { from: this.props.location }}}/>);
      //  }

      //console.log (this.props.name);

      if (localStorage.getItem('is_authorized') == 201) {
        //alert(this.props.name);
        if (CommonHelper.isNull(Entrance.accountId()) && this.props.name!=='LinkAccount') {
          //return (<Redirect to={{pathname: '/web-sch/link_account', state: { from: this.props.location }}}/>);
          //return (<Redirect to='/web-sch/link_account'/>);
          //return (<Route {LinkAccount}/>);
          //return (<Route exact path='/web-sch/link_account/' />);
          //return (<Redirect to={{pathname: '/web-sch/entrance', state: { from: this.props.location }}}/>);
          //return ( <Route exact path='/web-sch/link_account/' component={LinkAccount}/>);
          //r//eturn ( <Route exact path='/web-sch/about/' component={About}/>);
          return (<Redirect to={{pathname: Config.dirHostedAt+'/link_account', state: { from: this.props.location }}}/>);

          //LinkAccount
        }else if(Entrance.reAuthSignalDetected() && this.props.name!=='ReAuthAccount'){
          return (<Redirect to={{pathname: Config.dirHostedAt+'/reauth_account', state: { from: this.props.location }}}/>);
        }else
        {
          return (<Route {...rest}/>);
        }
      }else {
        return (<Redirect to={{pathname: Config.dirHostedAt+'/entrance', state: { from: this.props.location }}}/>);
      }

    }


}
